import isNumber from './isNumber';

const normalizeMaxValue = maximum => (isNumber(maximum) ? maximum : maximum.value);

export default normalizeMaxValue;
